<template>
    <div
        class="value"
        :class="{'red': dispayRedClass }"
    >
        {{ computedValue }}
    </div>
</template>

<script>

export default {

    components: {

    },

    props: {
        scope: {
            type: Object,
            required: true,
        },
        functionCalcROICoef: {
            type: Function,
            required: true,
        },
        negVal: {
            type: Function,
            required: true,
        },
    },

    data (){
        return {

        };
    },

    computed: {
        dispayRedClass (){
            if(this.scope.row.overridden){
                return this.isSolutionROIWithNewCoefNeg;
            }else{
                return this.negVal(this.scope.row.tri);
            }
        },

        isSolutionROIWithNewCoefNeg (){
            return this.negVal(this.solutionROIWithNewCoef);
        },
        solutionROIWithNewCoef (){
            return this.functionCalcROICoef(this.scope.row);
        },

        computedValue (){
            if(this.scope.row.overridden){
                if(this.isSolutionROIWithNewCoefNeg){
                    return 'Solution non rentable';
                }
                return this.solutionROIWithNewCoef;
            }
            let tri = this.scope.row.tri;
            if(this.negVal(tri)){
                return 'Solution non rentable';
            }
            if(tri >= 0 && tri < 20 ){
                return tri.toFixed(1);
            }else{
                return '>20';
            }
        },
    },

    mounted (){

    },

    methods: {
    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/page/report/ModalChooseEngineTriRow.vue